import './App.scss'
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import { ENV } from '@forwardflow/helpers/configs'
import AppAnalytics from './hooks/customHooks/appAnalytics'
import Routing from './router/Router'
import { SWRConfig } from 'swr'
import { MantineProvider } from '@mantine/core'
// import { ConfigProvider, theme } from 'antd'

import {
   ConfigCatProvider,
   createConsoleLogger,
   LogLevel,
} from 'configcat-react'
import * as Sentry from '@sentry/react'
import { initSentry } from './sentryConfig'
import ErrorFound from './pages/Error'
import { Suspense } from 'react'
import { Spinner } from './ui'
import { BrowserRouter } from 'react-router-dom'
import MaintenanceGate from './router/MaintenanceGate'

function App() {
   const logger = createConsoleLogger(LogLevel.Info)
   initSentry()

   return (
      <ConfigCatProvider sdkKey={ENV.CONFIGCAT_SDK_KEY} options={{ logger }}>
         <BrowserRouter>
            <Sentry.ErrorBoundary fallback={<ErrorFound />} showDialog>
               <SWRConfig
                  value={{
                     // Global configuration for all SWR hooks
                     refreshInterval: 0, // Disable automatic polling
                     revalidateOnFocus: false, // Disable revalidation on window focus
                     revalidateIfStale: false, // Don't revalidate stale data automatically
                     dedupingInterval: 2000, // Deduplicate requests within 2 seconds
                     errorRetryCount: 3,
                     shouldRetryOnError: false,
                     // Global fetcher configuration
                     fetcher: async (resource: any, init: any) => {
                        const res = await fetch(resource, init)
                        if (!res.ok) {
                           throw new Error('API request failed')
                        }
                        return res.json()
                     },
                  }}
               >
                  <Suspense
                     fallback={
                        <div className="min-h-screen flexc">
                           <Spinner />
                        </div>
                     }
                  >
                     <MantineProvider defaultColorScheme="dark">
                        <main className="min-h-screen">
                           <AppAnalytics />
                           <MaintenanceGate>
                              <Routing />
                           </MaintenanceGate>
                        </main>
                     </MantineProvider>
                  </Suspense>
               </SWRConfig>
            </Sentry.ErrorBoundary>
         </BrowserRouter>
      </ConfigCatProvider>
   )
}

export default App
